export var refreshJWT = function refreshJWT(klass, serverResponse) {
  var jwt = serverResponse.headers.get("X-JWT");
  if (jwt) {
    klass.setJWT(jwt);
  }
};